import React from 'react';
import bgImage from '../../assets/images/backgrounds/background_about.png'; // change to your image path

function AboutText(props) {
  return (
    <div className="about-text-section">
      <div
        className="about-text-section-wrapper bg-black text-center"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="about-text-section-inner">
  <br/><br/><br/><br/><br/>
                <h2 className="heading heading-large light-1">{props.content}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutText;
